import type { SelectOption } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';

import type { PreferenceTypeEnum } from 'src/common/external/bambi-api/bambiApi';

export type PreferenceDirection = 'pair' | 'avoid';
export type PreferenceStrictness = 'preference' | 'hard_rule';

export const directionOptions: SelectOption<PreferenceDirection>[] = [
  { label: 'Pair with this driver', value: 'pair' },
  { label: 'Avoid this driver', value: 'avoid' },
];

export const strictnessOptions: {
  label: string;
  value: PreferenceStrictness;
}[] = [
  {
    label: 'Preference — try to respect rule; allow alternatives if needed',
    value: 'preference',
  },
  {
    label: 'Hard rule — always respect rule',
    value: 'hard_rule',
  },
];

export function toPreferenceType(
  direction: PreferenceDirection,
  strictness: PreferenceStrictness
): PreferenceTypeEnum {
  if (direction === 'pair') {
    return strictness === 'hard_rule' ? 'demand' : 'prefer';
  }
  return strictness === 'hard_rule' ? 'prohibit' : 'avoid';
}

export function fromPreferenceType(type: PreferenceTypeEnum): {
  direction: PreferenceDirection;
  strictness: PreferenceStrictness;
} {
  switch (type) {
    case 'prefer':
      return { direction: 'pair', strictness: 'preference' };
    case 'demand':
      return { direction: 'pair', strictness: 'hard_rule' };
    case 'avoid':
      return { direction: 'avoid', strictness: 'preference' };
    case 'prohibit':
      return { direction: 'avoid', strictness: 'hard_rule' };
  }
}

export const preferenceTypeDisplay: Record<PreferenceTypeEnum, string> = {
  prefer: 'Preferred',
  demand: 'Required',
  avoid: 'Avoid',
  prohibit: 'Never assign',
};

export const isHardRule = (type: PreferenceTypeEnum) =>
  type === 'demand' || type === 'prohibit';
